export default __webpack_public_path__ + "static/media/partners12.386aff83.png";